import { adminQueryKeys as e } from "./adminQueryKeys.mjs";
import { setHasAdminSession as t } from "./adminSessionFlag.mjs";
import { useMutation as n, useQueryClient as r } from "@maat/store-hooks";
import { authApi as i } from "@maat/api-main";
//#region src/queries/admin/useAdminOAuthLoginMutation.ts
var a = () => {
	let a = r();
	return n({
		mutationFn: i.adminLoginWithOAuth,
		onSuccess: () => {
			t(!0), a.invalidateQueries({ queryKey: e.me() });
		}
	});
};
//#endregion
export { a as useAdminOAuthLoginMutation };
